
<div>
  <button class="add-btn" (click)="addData($event)">
  <i class="icon-add"></i>
</button>
</div>